import { render, staticRenderFns } from "./Siliao.vue?vue&type=template&id=24446566&scoped=true"
import script from "./Siliao.vue?vue&type=script&lang=js"
export * from "./Siliao.vue?vue&type=script&lang=js"
import style0 from "./Siliao.vue?vue&type=style&index=0&id=24446566&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24446566",
  null
  
)

export default component.exports